
// mixin.js
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {} from 'googlemaps';

// You can declare a mixin as the same style as components.
@Component
export default class GoogleMapsLoader extends Vue {
    @Prop(String) public readonly googleParams!: string;
    public googleMap: typeof google | null;
    public map: google.maps.Map | null;
    constructor() {
        super();
        this.map = null;
        this.googleMap = null;
    }

    public created() {
        const self = this;
        // @ts-ignore
        window.googleMapsAutoCompleteAPILoad = () => {
            // @ts-ignore
            self.googleMap = window.google;
        };
        const alreadyLoaded = document.getElementById('google-map-script');
        if (alreadyLoaded) {
            // @ts-ignore
            window.googleMapsAutoCompleteAPILoad();
            return;
        }
        const script = document.createElement('script');
        script.id = 'google-map-script';
        script.type = 'text/javascript';
        script.src =
            `https://maps.googleapis.com/maps/api/js?key=${this.googleParams}&callback=googleMapsAutoCompleteAPILoad`;
        // @ts-ignore
        document.querySelector('head').appendChild(script);
    }
}
